import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import ScheduleItem from '../ScheduleItem/ScheduleItem';

import styles from './ScheduleList.scss';

const ScheduleList = ({
    scheduleResponse,
}) => {
    const itemClassName = (idx) => {
        if (idx === 0) {
            return 'first';
        }
        if (idx + 1 === scheduleResponse.length) {
            return 'last';
        }
        return '';
    };

    return (
        <div className={styles.scheduleList}>
            {scheduleResponse.map((schedule, index) => (
                <ScheduleItem
                    className={classnames(
                        styles.scheduleItem,
                        {
                            [styles.first]: index === 0,
                            [styles.last]: index + 1 === scheduleResponse.length,
                        },
                    )}
                    key={index}
                    {...schedule}
                />
            ))}
        </div>
    );
};

ScheduleList.propTypes = {
    scheduleResponse: PropTypes.arrayOf(
        PropTypes.shape({
            vehicletypes: PropTypes.array.isRequired,
            carriercode: PropTypes.string.isRequired,
            carriername: PropTypes.string.isRequired,
            departdows: PropTypes.array.isRequired,
            departlocaltime: PropTypes.string.isRequired,
            departcityname: PropTypes.string.isRequired,
            departstationname: PropTypes.string.isRequired,
            arrivelocaltime: PropTypes.string.isRequired,
            arrivecityname: PropTypes.string.isRequired,
            arrivestationname: PropTypes.string.isRequired,
            duration: PropTypes.number.isRequired,
            minpriceusd: PropTypes.number.isRequired,
            transfers: PropTypes.number.isRequired,
        }),
    ).isRequired,
};

export default ScheduleList;
